( function( $ ) {

var pageId = 'page-invite-preview',
	page = '#' + pageId;

$(document).on('pjaxload#' + pageId, function(e, $page, page) {
    var invites = simple.util.storage.get('invites');
    if (invites) {
        invites = JSON.parse(invites);
        if (invites.invite_mail) {
            $('.extra-message').text(invites.invite_mail)
            $('.with-extra-msg').show();
        }
    }
});

})( jQuery );
